import { doAjax, updateTableValue, initStitchesBackgroundColorListeners, 
	initColorSelect, initRedPointLogic, setElementOnTop, fakeSelected } from './helper'
import { getSteeringWheelCustomizedComponentImage } from './imagesLogicController'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'

const initSteeringWheelCustomizing = () => {
	initColorSelect()
	const carModel = document.querySelector("input[name=carmodel]")?.value
	const isYn1Q7Q9 = aeo['configuration']['YN1_Q7Q9'] === true
	const is97rQ7G8 = aeo['configuration']['97R_Q7Q9'] === true
		&& ['115', '116', '117'].includes(carModel)
	const loadOptions = (isYn1Q7Q9 || is97rQ7G8) ? {} : {}
	loadAlreadyCustomizedOptions(() => {
		const steeringWheel = document.getElementById('steering-wheel')
		const rsBadgeImg = document.getElementById('rs-badge-img')

		if (steeringWheel && rsBadgeImg) {
			setElementOnTop('steering-wheel', 'rs-badge-img')
		}
	}, loadOptions)

	const isBasicWheel = aeo['configuration']['YVU_etron'] === true
	const isHourMarkWheel = aeo['configuration']['YVN'] === true || aeo['configuration']['0UD_RS5'] === true || aeo['configuration']['0UD_SQ6_perf'] === true || aeo['configuration']['0UQ_SQ6_perf'] === true
	const isA6A7wheel = (aeo['configuration']['YVU'] === true || aeo['configuration']['YVQ_RS6RS7'] === true || aeo['configuration']['0UD'] === true || aeo['configuration']['0UD_A5'] === true || aeo['configuration']['0UD_A6etron'] === true || aeo['configuration']['0UD_A6_C9'] === true || aeo['configuration']['0UD_RS5'] === true || aeo['configuration']['97R_Q7Q9'] === true || aeo['configuration']['0UD_SQ6_perf'] === true || aeo['configuration']['0UQ_SQ6_perf'] === true)
	const isAirbagCover = aeo['configuration']['YUH'] === true	

	//SteeringWheel Components Map (KEY = LEATHER, VALUE = STITCH)
	let steeringWheelComponents = !isBasicWheel ? {} : 
		{
			top: '',
			sides: 'stitches',
			bottom: ''
		}

		steeringWheelComponents = isA6A7wheel ? {} : 
		{
			top: '',
			sides: 'stitches',
			bottom: ''
		}
		if (isA6A7wheel == true) {
			//steeringWheelComponents['top'] = '';
			//steeringWheelComponents['stitches'] = 'stitches';  
			steeringWheelComponents['sides_A6A7'] = 'stitches';
			//steeringWheelComponents['bottom'] = '';
			//steeringWheelComponents['stitchHourMark'] = '';
			//steeringWheelComponents['hourMark'] = '';	
		}
		if ((isA6A7wheel == true) && (isHourMarkWheel == true)) { // RS5
			steeringWheelComponents['sides_A6A7'] = 'stitches';
			steeringWheelComponents['hourMark'] = '';	
			steeringWheelComponents['top'] = '';
		}
		if (isHourMarkWheel == true) {
			steeringWheelComponents['top'] = '';
			steeringWheelComponents['sides'] = '';
			steeringWheelComponents['bottom'] = '';
		}
		
		if (isAirbagCover == true) {
			steeringWheelComponents['top'] = '';
			steeringWheelComponents['sides'] = '';
			steeringWheelComponents['bottom'] = '';
			steeringWheelComponents['stitchHourMark'] = '';
			steeringWheelComponents['hourMark'] = '';
			steeringWheelComponents['AirbagCoverLeather'] = 'AirbagCoverLeather';
			steeringWheelComponents['AirbagCoverStitches'] = 'AirbagCoverStitches';
			//steeringWheelComponents['sides_A6A7'] = '';
		}
		

		

	//var steeringWheelModel_check = document.getElementsByName("steering-wheel-model")[0].value
	if (isHourMarkWheel) steeringWheelComponents['hourMark'] = 'stitchHourMark'
	if (isA6A7wheel) steeringWheelComponents['GearLeverStitches'] = 'GearLeverStitches'


	for (const key in steeringWheelComponents) {
		if (Object.hasOwnProperty.call(steeringWheelComponents, key)) {
				
			const leatherComponent = key
			const stitchComponent = steeringWheelComponents[leatherComponent];
			const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
			//load stitching component logic
			if (stitchComponent != '') {
				
				const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
				initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, setImage)
				if ((leatherComponent != 'hourMark') && (leatherComponent != 'GearLeverStitches')  && (leatherComponentMatchingDotId != 'dot_wheel-kontrastnaht-A6A7') && (leatherComponent != 'AirbagCoverLeather') && (leatherComponent != 'AirbagCoverStitches')) {
					
					if (document.getElementsByName("steering-wheel-model")[0].value < 10 ) { // nur für e-tron und A6/A7
						initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId)
					}
				}
			}
			//load leather component logic
			initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, setImage)
		}
	}
}

/**Returns the DOT ID for the component on params  */
function getDotIdWithComponent(component) {
	switch (component) {
		case 'top': return 'dot_kranz-oben'
		case 'sides': return 'dot_kranz-rechts-links'
		case 'sides_A6A7': return 'dot_wheel-kontrastnaht-A6A7'
		case 'bottom': return 'dot_kranz-unten'
		case 'stitches': return 'dot_wheel-kontrastnaht'
		case 'hourMark': return 'dot_12oclock_mark'
		case 'stitchHourMark': return 'dot_12oclock_mark-stitch'
		case 'GearLeverStitches': return 'dot_gear_lever'
		case 'AirbagCoverLeather': return 'dot_airbagcover-leather'
		case 'AirbagCoverStitches': return 'dot_airbagcover-kontrastnaht'
		default: break;
	}
	
}

function setStitchColorPrimSec(component, colorCode) {
	setImage(component, colorCode) 
	fakeSelected(getDotIdWithComponent(component), colorCode)
}

function setImage(component, colorCode) {	 
	/*if(component == 'top') {

		const color214 = document.querySelector('#dot_12oclock_mark .color.c-214');
		const color8 = document.querySelector('#dot_12oclock_mark .color.c-8');

		if (color214 && color8) {
			if (colorCode == '214') {
				color214.classList.add('visible');
				color214.classList.remove('hidden');
				//color8.classList.add('hidden');
				color8.classList.remove('visible');
			} else if (colorCode == '8') {
				color8.classList.add('visible');
				color8.classList.remove('hidden');
				//color214.classList.add('hidden');
				color214.classList.remove('visible');
			}
		}

		let fakeSelectComponent = 'hourMark'
		let fakeSelectColorCode = document.querySelector('#'+fakeSelectComponent+' td[color-code]').getAttribute('color-code')
		if (fakeSelectColorCode == 8 || fakeSelectColorCode == 214)
			{
				setImage(fakeSelectComponent, colorCode) 
				fakeSelected(getDotIdWithComponent(fakeSelectComponent), colorCode)

				
			}
	}*/
 
	if(component == 'AirbagCoverLeather' 
		&& (document.querySelector('#AirbagCoverLeather td[color-code]').getAttribute('color-code') == document.querySelector('#AirbagCoverStitches td[color-code]').getAttribute('color-code')
			|| document.querySelector('#AirbagCoverStitches td[color-code]').getAttribute('color-code') == 99 )) {
		setStitchColorPrimSec('AirbagCoverStitches', colorCode)
	}
	
	if ($("#GearLeverStitches").length ) {
		if(component == 'stitches' 
		&& (document.querySelector('#GearLeverStitches td[color-code]').getAttribute('color-code') == document.querySelector('#stitches td[color-code]').getAttribute('color-code')
			|| document.querySelector('#GearLeverStitches td[color-code]').getAttribute('color-code') == 99 )) {
		setStitchColorPrimSec('GearLeverStitches', colorCode)
	}
	}
	/*
	if(component == 'stitches' 
		&& (document.querySelector('#GearLeverStitches td[color-code]').getAttribute('color-code') == document.querySelector('#stitches td[color-code]').getAttribute('color-code')
			|| document.querySelector('#GearLeverStitches td[color-code]').getAttribute('color-code') == 99 )) {
		setStitchColorPrimSec('GearLeverStitches', colorCode)
	}
	*/


	let steeringWheelModel = document.getElementsByName("steering-wheel-model")[0].value;
	let imageSource = getSteeringWheelCustomizedComponentImage(component, colorCode)


	/*if (colorCode == "8" && component == "hourMark"){
		imageSource = "" //quickfix since we dont have the image
	}*/
	if (imageSource <= 2) {
		replaceImage(imageSource, component,'steering_wheel')
	} else {
		replaceImage(imageSource, component,'steering_wheel_1')
	}


	updateTableValue(component, colorCode, 'wheel-components')
	const steeringWheelJson = createSeatJson(imageSource, component, colorCode)
	doAjax(steeringWheelJson)
}

function createSeatJson(imageSource, component, colorCode) {
	const json = {};
	json['steering_wheel_component'] = component
	json['color'] = colorCode
	json['src'] = imageSource
	return json;
}

export { initSteeringWheelCustomizing };